import React from "react";

// Lets styled() target a custom element (e.g. `mrcl-button`). With a bare tag
// string, styled-components drops props that are not standard HTML attributes
// (variant, tone…), and React 18 renders `className` on custom elements as a
// literal `classname` attribute, so the generated class never applies.
// Wrapping the tag in a component makes styled() forward every prop, and the
// class is set explicitly here.
export const customElement = (tag: string) =>
  React.forwardRef<HTMLElement, any>(({ className, ...rest }, ref) =>
    React.createElement(tag, { ...rest, class: className, ref })
  );
